
<template>
    <el-container v-wechat-title="title" :style="{ height: screenHeight2 - 10 + `px` }" v-if="surgeryId > 0">
        <el-aside width="260px" v-show="collapse == 0">
            <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                <el-menu :unique-opened="docUniqueOpened" style="margin-top: 40px" class="document-list">
                    <template v-for="(groupitem, groupindex) in newdocumentList">
                        <!-- 文书分组 -->
                        <el-tooltip v-if="groupitem.groupchildren && groupitem.groupchildren.length>0"
                            :key="groupitem.index"
                            class="item"
                            effect="light"
                            :content="groupitem.label"
                            placement="right"
                        >
                            <el-submenu :index="groupitem.index" :key="groupindex">
                                <div slot="title" class="align-left" style="font-weight: bold;">
                                    <span class="el-icon-folder"></span>
                                    <span style="width: 160px" class="ellipsis">{{ groupitem.label }}</span>
                                </div>
                                <template v-for="(item, index) in groupitem.groupchildren">
                                    <el-tooltip v-if="item.hasChildren && (!item.is_singleton || isTemplate > 0)"
                                        :disabled="item.label.length < 10"
                                        :key="item.Sysid"
                                        class="item"
                                        effect="light"
                                        :content="item.label"
                                        placement="right"
                                    >
                                        <el-submenu :index="item.index" :key="index">
                                            <div slot="title" class="align-left">
                                                <span class="el-icon-document"></span>
                                                <span style="width: 160px" class="ellipsis">{{ item.label }}({{ item.children.length }})</span>
                                                <span
                                                    v-if="isTemplate == '0' && !currentSurgery.is_sealed"
                                                    class="btn iconfont icon-xinzeng_xian fg-primary cus-button is-circle"
                                                    @click.stop="loadNewDocumentView(item)"
                                                ></span>
                                            </div>
                                            <el-menu-item style="position: relative;text-align: left;height: 50px;line-height: 50px;" v-for="c in item.children" :key="c.index" :index="c.index" @click="loadDocumentPage(c)">
                                                <span v-show="isTemplate == 0" style="position: absolute;left: 20px;top: 50%;transform: translateY(-50%);" :class="c.isCenterSign==1 ? `el-icon-circle-check fg-sucess` : (c.isCenterSign==0 ? `el-icon-warning-outline fg-danger` : `fg-sucess`)"
                                                    :title="c.isCenterSign==1 ? `已签名` : (c.isCenterSign==0 ? `签名未完成` : ``)"></span>
                                                <div slot="title" class="align-left">
                                                    <span :class="c.archiveddt ? `el-icon-document fg-sucess` : ``" :title="c.archiveddt ? '已归档' : ''"></span>
                                                    {{ c.label }}
                                                    <span :class="c.printdt ? `iconfont icon-dayin fg-sucess` : `fg-danger`" :title="c.printdt ? '已打印' : ''"></span>
                                                    <span
                                                        :class="`el-icon-upload` + ` ` + (c.uploadRec && c.uploadRec.flag == 1 ? `fg-sucess` : `fg-danger`)"
                                                        v-if="PaperlessEnabled == `1`"
                                                        :title="c.uploadRec && c.uploadRec.flag == 1 ? `上传人:` + c.uploadRec.last_upload_by_name + `,上传时间：` + c.uploadTime : `未上传`"
                                                    ></span>
                                                    <span title="私有模板" class="el-icon-user fg-warning" v-if="c.istemplate == '2'"></span>
                                                    <span
                                                        v-if="c.archiveddt == '' && !currentSurgery.is_sealed && hasMultipleDocDeleteButtonPermission"
                                                        class="btn el-icon-delete fg-danger cus-button is-circle"
                                                        @click.stop="deleteInstanceDocument(c)"
                                                    ></span>
                                                </div>
                                            </el-menu-item>
                                        </el-submenu>
                                    </el-tooltip>
                                    <el-tooltip v-else-if="isTemplate == '0'" :disabled="item.label.length < 10" :key="item.index" class="item" effect="light" :content="item.label" placement="right">
                                        <el-menu-item style="position: relative;text-align: left;height: 50px;line-height: 50px;" :key="item.index" :index="item.index" @click="loadDocumentPage(item)">
                                            <span style="position: absolute;left: 0;top: 50%;transform: translateY(-50%);" :class="item.isCenterSign==1 ? `el-icon-circle-check fg-sucess` : (item.isCenterSign==0 ? `el-icon-warning-outline fg-danger` : `fg-sucess`)"
                                                :title="item.isCenterSign==1 ? `已签名` : (item.isCenterSign==0 ? `签名未完成` : ``)"></span>
                                            <div slot="title" class="align-left">
                                                <span :class="item.archived ? 'el-icon-document fg-sucess' : 'el-icon-document '" :title="item.archived ? '已归档' : ''"></span>
                                                <span class="ellipsis" style="width: 135px">{{ item.label }}</span>
                                                <span
                                                    style="width: 10px"
                                                    :class="item.children.length > 0 ? 'btn el-icon-delete fg-danger cus-button is-circle' : ''"
                                                    v-if="hasSingleDocDeleteButtonPermission && item.children && item.children[0]"
                                                    @click.stop="deleteInstanceDocument(item.children[0])"
                                                ></span>
                                                <span :class="item.printdt > 0 ? `iconfont icon-dayin fg-sucess` : `fg-danger`" :title="item.printdt > 0 ? '已打印' : ''"></span>
                                                <span
                                                    :class="`el-icon-upload` + ` ` + (item.uploadRec && item.uploadRec.flag == 1 ? `fg-sucess` : `fg-danger`)"
                                                    v-if="PaperlessEnabled == `1`"
                                                    :title="item.uploadRec && item.uploadRec.flag == 1 ? `上传人:` + item.uploadRec.last_upload_by_name + `,上传时间：` + item.uploadTime : `未上传`"
                                                ></span>
                                            </div>
                                        </el-menu-item>
                                    </el-tooltip>
                                </template>
                            </el-submenu>
                        </el-tooltip>
                        <!-- 多例文书或模板 -->
                        <el-tooltip v-if="!groupitem.groupchildren && groupitem.hasChildren && (!groupitem.is_singleton || isTemplate > 0)"
                            :disabled="groupitem.label.length < 10"
                            :key="groupitem.Sysid"
                            class="item"
                            effect="light"
                            :content="groupitem.label"
                            placement="right"
                        >
                            <el-submenu :index="groupitem.index" :key="groupitem.index">
                                <div slot="title" class="align-left">
                                    <span class="el-icon-document"></span>
                                    <span style="width: 160px" class="ellipsis">{{ groupitem.label }}({{ groupitem.children.length }})</span>
                                    <span
                                        v-if="isTemplate == '0' && !currentSurgery.is_sealed"
                                        class="btn iconfont icon-xinzeng_xian fg-primary cus-button is-circle"
                                        @click.stop="loadNewDocumentView(groupitem)"
                                    ></span>
                                </div>
                                <template>
                                    <el-menu-item style="position: relative;text-align: left;height: 50px;line-height: 50px;" v-for="(c, cindex) in groupitem.children" :key="cindex" :index="c.index" @click="loadDocumentPage(c)">
                                        <span v-show="isTemplate == 0" style="position: absolute;left: 20px;top: 50%;transform: translateY(-50%);" :class="c.isCenterSign==1 ? `el-icon-circle-check fg-sucess` : (c.isCenterSign==0 ? `el-icon-warning-outline fg-danger` : `fg-sucess`)"
                                            :title="c.isCenterSign==1 ? `已签名` : (c.isCenterSign==0 ? `签名未完成` : ``)"></span>
                                        <div slot="title" class="align-left">
                                            <span :class="c.archiveddt ? `el-icon-document fg-sucess` : ``" :title="c.archiveddt ? '已归档' : ''"></span>
                                            {{ c.label }}

                                            <span :class="c.printdt ? `iconfont icon-dayin fg-sucess` : `fg-danger`" :title="c.printdt ? '已打印' : ''"></span>
                                            <span
                                                :class="`el-icon-upload` + ` ` + (c.uploadRec && c.uploadRec.flag == 1 ? `fg-sucess` : `fg-danger`)"
                                                v-if="PaperlessEnabled == `1`"
                                                :title="c.uploadRec && c.uploadRec.flag == 1 ? `上传人:` + c.uploadRec.last_upload_by_name + `,上传时间：` + c.uploadTime : `未上传`"
                                            ></span>
                                            <span title="私有模板" class="el-icon-user fg-warning" v-if="c.istemplate == '2'"></span>
                                            <span
                                                v-if="c.archiveddt == '' && !currentSurgery.is_sealed && hasMultipleDocDeleteButtonPermission"
                                                class="btn el-icon-delete fg-danger cus-button is-circle"
                                                @click.stop="deleteInstanceDocument(c)"
                                            ></span>
                                        </div>
                                    </el-menu-item>
                                </template>
                            </el-submenu>
                        </el-tooltip>
                        <!-- 单例文书 -->
                        <el-tooltip v-else-if="!groupitem.groupchildren && isTemplate == '0'" :disabled="groupitem.label.length < 10" :key="groupitem.index" class="item" effect="light" :content="groupitem.label" placement="right">
                            <el-menu-item style="position: relative;text-align: left;height: 50px;line-height: 50px;" :key="groupitem.index" :index="groupitem.index" @click="loadDocumentPage(groupitem)">
                                <span style="position: absolute;padding-left: 2px;left: 0;top: 50%;transform: translateY(-50%);" :class="groupitem.isCenterSign==1 ? `el-icon-circle-check fg-sucess` : (groupitem.isCenterSign==0 ? `el-icon-warning-outline fg-danger` : `fg-sucess`)"
                                    :title="groupitem.isCenterSign==1 ? `已签名` : (groupitem.isCenterSign==0 ? `签名未完成` : ``)"></span>
                                <div slot="title" class="align-left">
                                    <span :class="groupitem.archived ? 'el-icon-document fg-sucess' : 'el-icon-document '" :title="groupitem.archived ? '已归档' : ''"></span>
                                    <span class="ellipsis" style="width: 135px">{{ groupitem.label }}</span>
                                    <span
                                        style="width: 10px"
                                        :class="groupitem.children.length > 0 ? 'btn el-icon-delete fg-danger cus-button is-circle' : ''"
                                        v-if="hasSingleDocDeleteButtonPermission && groupitem.children && groupitem.children[0]"
                                        @click.stop="deleteInstanceDocument(groupitem.children[0])"
                                    ></span>
                                    <span :class="groupitem.printdt > 0 ? `iconfont icon-dayin fg-sucess` : `fg-danger`" :title="groupitem.printdt > 0 ? '已打印' : ''"></span>
                                    <span
                                        :class="`el-icon-upload` + ` ` + (groupitem.uploadRec && groupitem.uploadRec.flag == 1 ? `fg-sucess` : `fg-danger`)"
                                        v-if="PaperlessEnabled == `1`"
                                        :title="groupitem.uploadRec && groupitem.uploadRec.flag == 1 ? `上传人:` + groupitem.uploadRec.last_upload_by_name + `,上传时间：` + groupitem.uploadTime : `未上传`"
                                    ></span>
                                </div>
                            </el-menu-item>
                        </el-tooltip>
                    </template>
                </el-menu>
            </el-scrollbar>
        </el-aside>
        <el-main class="width-p100" style="padding: 0; overflow-y: auto; overflow-x: hidden">
            <div class="width-p100" style="position: absolute; background: whitesmoke; margin-left: -260px; z-index: 2; display: flex; justify-content: flex-start; align-items: center; height: 40px">
                <el-radio-group v-model="isTemplate" size="small" style="width: 260px; text-align: left">
                    <el-radio-button :label="0">文书</el-radio-button>
                    <el-radio-button :label="1" v-if="hasTemplateButtonPermission">模板管理</el-radio-button>
                </el-radio-group>
                <i style="cursor: pointer" :class="collapse == 1 ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="triggerCollapse()"></i>
                <div class="inline-block" v-if="activeDoc">
                    <div style="display: inline; justify-content: flex-start; align-items: center">
                        <label v-if="showTemp">引用模板：</label>
                        <div v-if="showTemp" class="inline-block width180">
                            <item-input
                                type="groupselect"
                                :popperAppendToBody="true"
                                :options="activeDoc.templates"
                                v-model="activeDoc.templateid"
                                placeholder="默认模板"
                                :clearable="true"
                                @input="templateChange"
                            ></item-input>
                        </div>
                        <label v-if="activeDoc.datetype > 1 && (!activeDoc.caStatus || activeDoc.caStatus <= 0)">&nbsp;日期：</label>
                        <item-input
                            v-if="activeDoc.datetype == 2 && (!activeDoc.caStatus || activeDoc.caStatus <= 0)"
                            style="width: 160px"
                            type="date"
                            v-model="activeDoc.occurdate"
                            @input="occurdateChange"
                        ></item-input>
                        <item-input
                            v-else-if="activeDoc.datetype == 3 && (!activeDoc.caStatus || activeDoc.caStatus <= 0)"
                            style="width: 240px"
                            type="daterange"
                            v-model="activeDoc.daterange"
                            @input="daterangeChange"
                        ></item-input>
                    </div>
                    <el-link
                        type="primary"
                        v-if="activeDoc.isSurportHtml && !currentSurgery.is_sealed && hasSeveButtonPermission && !activeDoc.archived && (!activeDoc.caStatus || activeDoc.caStatus <= 0 || activeDoc.is_sign_multiple_times)"
                        size="mini"
                        @click="saveDoc"
                        class="margin20 margin-none-v"
                        v-preventReClick
                        ><span class="iconfont icon-baocun-xian"></span>保存</el-link
                    >
                    <el-link
                        type="primary"
                        v-if="!currentSurgery.is_sealed && activeDoc.archived && isTemplate == 0 && hasDisArchivePermission"
                        size="mini"
                        @click="disArchive(activeDoc)"
                        class="margin20 margin-none-v"
                        ><span class="iconfont icon-quxiaoshoucang"></span>取消归档</el-link
                    >
                    <el-link type="primary" v-else-if="!currentSurgery.is_sealed && isTemplate == 0 && hasArchivePermission" size="mini" @click="archive(activeDoc)" class="margin20 margin-none-v"
                        ><span class="iconfont icon-shoucang"></span>归档</el-link
                    >
                    <el-link type="primary" v-if="isTemplate == 0 && hasPrintButtonPermission" size="mini" @click="printDocment(activeDoc)" class="margin20 margin-none-v"
                        ><span class="iconfont icon-dayin"></span>打印</el-link
                    >
                    <el-dropdown @command="saveAsTemplate" v-if="activeDoc.isSurportHtml && !activeDoc.archived && (!activeDoc.caStatus || activeDoc.caStatus <= 0)">
                        <el-link type="primary" size="mini" v-if="hasSaveAsTemplatePermission"
                            ><span class="iconfont icon-lingcunweimoban"></span>另存为模板<i class="el-icon-arrow-down el-icon--right"></i
                        ></el-link>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="2">私有模板</el-dropdown-item>
                            <el-dropdown-item command="1" v-show="hasRegionTemplateEditPermission">区域模板</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-link
                        type="primary"
                        v-if="activeDoc.isSurportHtml && !currentSurgery.is_sealed && hasSendSignButtonPermission && !activeDoc.archived && (!activeDoc.caStatus || activeDoc.caStatus <= 0 || activeDoc.is_sign_multiple_times)"
                        size="mini"
                        @click="sendWztSign"
                        class="margin20 margin-none-v"
                        ><span class="iconfont el-icon-s-promotion"></span>发送签名</el-link
                    >
                    <el-link
                        type="primary"
                        v-if="activeDoc.isSurportHtml && !currentSurgery.is_sealed && hasCancelSignButtonPermission && !activeDoc.archived && activeDoc.caStatus && activeDoc.caStatus > 0"
                        size="mini"
                        @click="cancelWztSign"
                        class="margin20 margin-none-v"
                        ><span class="iconfont el-icon-remove"></span>取消签名</el-link
                    >
                    <el-link
                        type="primary"
                        v-if="activeDoc.isSurportHtml && !currentSurgery.is_sealed && hasRefreshButtonPermission && !activeDoc.archived && (!activeDoc.caStatus || activeDoc.caStatus <= 0)"
                        size="mini"
                        @click="refreshDocument"
                        class="margin20 margin-none-v"
                        ><span class="iconfont icon-shuaxin"></span>刷新</el-link
                    >
                    <el-link
                        type="primary"
                        v-if="activeDoc.isSurportHtml && !currentSurgery.is_sealed && hasDataSynchronizationPermission && !activeDoc.archived && (!activeDoc.caStatus || activeDoc.caStatus <= 0)"
                        size="mini"
                        @click="dataSynchronous"
                        class="margin20 margin-none-v"
                        ><span class="iconfont icon-shuaxin"></span>数据同步</el-link
                    >
                    <el-link type="primary" style="font-size: larger; margin-left: 5px" @click="changescalenum(0.1)"><span class="el-icon-zoom-in" title="放大"></span></el-link>
                    <el-link type="primary" style="font-size: larger; margin-left: 5px" @click="changescalenum(-0.1)"><span class="el-icon-zoom-out" title="缩小"></span></el-link>
                </div>

                <el-link type="primary" v-if="isTemplate == 0 && hasBatchPrintButtonPermission" size="mini" @click="openbatchPrint" class="margin20 margin-none-v"
                    ><span class="iconfont icon-dayin"></span>批量打印</el-link
                >
                <el-link type="primary" v-if="isTemplate == 0 && hasBatchArchiveButtonPermission" size="mini" @click="openbatchArchive" class="margin20 margin-none-v"
                    ><span class="iconfont icon-shoucang"></span>批量归档</el-link
                >
            </div>
            <DocFrame
                v-if="activeDoc"
                :resetHeight="false"
                :style="{ 'margin-top': '42px', height: screenHeight2 - 43 + `px`, transform: 'scale(' + this.scalenum + ')', 'transform-origin': 'center top' }"
                ref="doc"
                :docno="activeDoc.docno"
                :guid="activeDoc.guid"
                :printer_name2="activeDoc.default_printer_name"
                :surgeryId="surgeryId"
                :docname="activeDoc.docName"
                :fromDt="activeDoc.fromDt"
                :toDt="activeDoc.toDt"
                :isSurportHtml="activeDoc.isSurportHtml"
                :templateid="activeDoc.templateid"
                :docbizid.sync="activeDoc.docbizid"
                :isHide="!activeDoc.archived"
                :caStatus="activeDoc.caStatus"
                :isSignMultipleTimes="activeDoc.is_sign_multiple_times"
                @afterarchive="afterArchive"
                @afterdisarchive="afterDisarchive"
                @changed="changed"
                @saved="afterActiveSaved"
                @aftersaveastemplate="afterSaveAsTemplate"
                @aftercheckprint="aftercheckprint"
                :extraParams="{ isShowSendPrintMessage: isShowSendPrintMessage }"
            ></DocFrame>
            <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
        </el-main>
        <cus-dialog
            :title="document.title"
            :visible.sync="document.dialogFormVisible"
            width="80%"
            :okVisible="!hasSaveAndPrintButtonPermission"
            @confirm="createDocument"
            :saveAndPrintVisible="hasSaveAndPrintButtonPermission"
            :overflow="false"
            @saveAndPrint="saveAndPrintDocument"
        >
            <div style="display: flex; justify-content: flex-start; align-items: center">
                <label>模板：</label>
                <div class="inline-block width180">
                    <item-input type="groupselect" :options="document.templates" v-model="document.templateid" placeholder="默认模板" :clearable="true"></item-input>
                </div>
                <label v-if="document.datetype > 1">&nbsp;日期：</label>
                <item-input v-if="document.datetype == 2" style="width: 160px" type="date" :options="[]" v-model="document.occurdate"></item-input>
                <item-input v-else-if="document.datetype == 3" style="width: 240px" type="daterange" :options="[]" v-model="document.daterange"></item-input>
            </div>
            <DocFrame
                ref="doc-new"
                :docbizid.sync="document.docbizid"
                :docno="document.docno"
                :printer_name2="document.default_printer_name"
                guid=""
                :surgeryId="surgeryId"
                :templateid="document.templateid"
                :fromDt="document.fromDt"
                :toDt="document.toDt"
                :docname="document.docname"
                @saved="afterDocumentSaved"
                @saveAndPrint="afterDocumentSavedAndPrint"
            ></DocFrame>
        </cus-dialog>

        <el-dialog :title="`文书批量${batchDoc.title}`" :visible.sync="batchDoc.visibleSync" :close-on-click-modal="false" width="30%" :destroy-on-close="true">
            <div style="height: 500px">
                <TreeTable
                    :showSequence="false"
                    :selection="true"
                    ref="printtb"
                    :datalist="batchDoc.datalist"
                    :tableHeight="480"
                    :columns="printColumnList"
                    :treeStyle="true"
                    :parentField="batchDoc.parentField"
                    :idField="batchDoc.idField"
                    :autoSelectParent="false"
                    :autoSelect="false"
                    @select="selectDocItems"
                >
                    <template slot="plabel" slot-scope="{ row }">
                        <div style="white-space: normal">
                            <span :style="{ 'padding-left': row.parentId > 0 ? '40px' : '20px' }">{{ row.label }}</span>
                            <span v-if="row.docbizid" class="el-icon-document fg-primary"></span>
                        </div>
                    </template>
                </TreeTable>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-show="batchDoc.title == `打印`" @click="batchPrintDocment">打 印</el-button>
                <el-button type="primary" v-show="batchDoc.title == `归档`" @click="batchArchiveDocment">归 档</el-button>
                <el-button @click="batchDocClose">取 消</el-button>
            </div>
        </el-dialog>
    </el-container>
    <p v-else class="no-surgery">暂无手术</p>
</template>

<script>
import axios from 'axios'
import pdf from '@/common/vue-pdf-4.1.0'
import { mapGetters } from 'vuex'

export default {
    name: `Document2`,
    components: {
        pdf
    },
    props: {},
    data() {
        let isSingletonDocShowTemplateVal = this.$root.isSingletonDocShowTemplate || `false`
        return {
            isButtonDisabled: false,
            collapse: this.$route.query.docId && this.$route.query.docId > 0 ? 1 : 0,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            catoken: this.$route.query.catoken,
            recordType: this.$route.query.record_type,
            currentPage: 1,
            pageCount: 0,
            alivable: false,
            loadingTask: null,
            documentList: [],
            newdocumentList: [],
            htmlDocumentList: [],
            multiDocmentList: [],
            activeDoc: undefined,
            title: `文书编辑`,
            visible: false,
            src: ``,
            isSave: true,
            isShowSendPrintMessage: this.$root.isShowSendPrintMessage || `false`,
            isSingletonDocShowTemplate: isSingletonDocShowTemplateVal.toUpperCase() == `TRUE` || isSingletonDocShowTemplateVal.toUpperCase() == `1`,
            isCanPrintDocAfterArchived: this.$root.IsCanPrintDocAfterArchived || 0,
            isTemplate: 0,
            document: {
                title: `创建文书`,
                dialogFormVisible: false,
                docno: 1,
                docname: ``,
                datetype: 2,
                templateid: undefined,
                daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                toDt: this.$moment().format(`YYYY/MM/DD HH:mm`)
            },
            batchDoc: {
                title: ``,
                visibleSync: false,
                datalist: [],
                parentField: `parentId`,
                idField: `id`
            },
            paperlessDocRecords: [],
            printlogDocRecords: [],
            PaperlessEnabled: this.$root.PaperlessEnabled,
            hasChanged: false,
            nextActive: undefined,
            archivedId: undefined,
            archivedIds: [],
            singleItems: [],
            isSaving: false,
            default_printer_name: null,
            scalenum: 1,
            paperlessDocVerification: this.$root.carte_PaperlessDocVerification,
            useExternalSignature: this.$root.UseExternalSignature,
            docProcBeforeArchive: this.$root.BeforeDocArchiveProc && _.includes(this.$root.BeforeDocArchiveProc.trim().toLowerCase(), `proc_`),
            docGroupNamesConfig: this.$root.DocGroupNamesConfig,
            docUniqueOpened: !(this.$root.DocUniqueOpened && this.$root.DocUniqueOpened == `0`),
            ztdocID: this.$root.DOCUMENT[`ZTSF001`],
            docId: this.$route.query.docId,
            isOnly: this.$route.query.isOnly,
            checkPrintByDoc: this.$root.CheckPrintByDoc,
            docSaveByBtn: (this.$root.DocSaveByBtn || `0`) == `1`
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`, `currentSurgery`, `active_ward`, `permissions`, `localip/ipAddress`]),
        isOperationWard() {
            if (this.recordType) {
                if (this.recordType == `2`) {
                    return false
                } else {
                    return true
                }
            } else {
                return _.startsWith(this.active_ward.value, `ow_`)
            }
        },
        printColumnList() {
            return [
                { type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false
                },
                { type: `custom`,
                    prop: `plabel`,
                    label: `名称`
                }
            ]
        },
        screenHeight2() {
            let r = typeof winformMsg
            if (r != `undefined` && this.$route.path == `/document2`) {
                // 麻醉单里面的文书tab页签
                return this.screenHeight - 126
            } else {
                return this.screenHeight - 106
            }
        },
        hasRegionTemplateEditPermission() {
            return _.find(this.permissions, { no: `doc_region_template_edit` }) != undefined
        },
        hasArchivePermission() {
            return _.find(this.permissions, { no: `Document:Archive` }) != undefined
        },
        hasDisArchivePermission() {
            return _.find(this.permissions, { no: `Document:DisArchive` }) != undefined
        },
        hasTemplateButtonPermission() {
            return _.find(this.permissions, { no: `Document:TemplateButton` }) != undefined
        },
        hasSeveButtonPermission() {
            return _.find(this.permissions, { no: `Document:SeveButton` }) != undefined
        },
        hasPrintButtonPermission() {
            return _.find(this.permissions, { no: `Document:PrintButton` }) != undefined
        },
        hasBatchPrintButtonPermission() {
            return _.find(this.permissions, { no: `Document:BatchPrintButton` }) != undefined
        },
        hasBatchArchiveButtonPermission() {
            return _.find(this.permissions, { no: `Document:BatchArchiveButton` }) != undefined
        },
        hasSaveAndPrintButtonPermission() {
            return _.find(this.permissions, { no: `Document:SaveAndPrint` }) != undefined
        },
        hasRefreshButtonPermission() {
            return _.find(this.permissions, { no: `Document:RefreshButton` }) != undefined
        },
        hasSendSignButtonPermission() {
            return _.find(this.permissions, { no: `Document:SendSign` }) != undefined && this.useExternalSignature && this.useExternalSignature == `1`
        },
        hasCancelSignButtonPermission() {
            return _.find(this.permissions, { no: `Document:CancelSign` }) != undefined && this.useExternalSignature && this.useExternalSignature == `1`
        },
        hasSaveAsTemplatePermission() {
            return _.find(this.permissions, { no: `Document:SaveAsTemplate` }) != undefined
        },
        hasDataSynchronizationPermission() {
            return _.find(this.permissions, { no: `Document:DataSynchronization` }) != undefined
        },
        hasMultipleDocDeleteButtonPermission() {
            return _.find(this.permissions, { no: `Document:MultipleDocDeleteButton` }) != undefined
        },
        hasSingleDocDeleteButtonPermission() {
            return _.find(this.permissions, { no: `Document:SingleDocDeleteButton` }) != undefined
        },
        showTemp() {
            if (this.activeDoc && !this.activeDoc.archived && this.activeDoc.isSurportHtml && this.activeDoc.is_singleton) {
                if (this.isSingletonDocShowTemplate) {
                    return true
                } else {
                    return !this.activeDoc.hasChildren
                }
            } else {
                return false
            }
        }
    },
    created() {
        let that = this
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            if (this.catoken) {
                sessionStorage.setItem(`caToken`, this.catoken)
            }
        }
        // 获取工作站
        that.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(() => {
            console.log(`ipAddress`, that[`localip/ipAddress`])
            that.$store.dispatch(`ADD_WORKBAR`).then(() => {
                that.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
                    that.getToken().then(() => {
                        that.loadWorkstationConfig().then(() => {
                            that.init().then(() => {
                                that.loadPaperlessDocRecordList(that.surgeryId).then(() => {
                                    that.loadDocumentList()
                                }).catch(e => {
                                    console.log(`loadPaperlessDocRecordList error`, e)
                                })
                            }).catch(e => {
                                console.log(`init error`, e)
                            })
                        })
                    })
                })
            })
        })
    },
    mounted() {
    },
    methods: {
        getToken() {
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` }
                })
                req.then(res => {
                    if (res != null && res.Status === `SUCCESS`) {
                        sessionStorage.setItem(`doctoken`, res.Content)
                    }
                    resolve(res)
                }).catch(err => {
                    console.log(err)
                })
            })
        },
        loadWorkstationConfig() {
            console.log(this[`localip/ipAddress`])
            return new Promise((resolve, reject) => {
                if (!this[`localip/ipAddress`]) {
                    resolve()
                } else {
                    let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${this[`localip/ipAddress`]}`)
                    req.then(data => {
                        if (data) {
                            console.log(`当前工作站`, data)
                            this.default_printer_name = data.default_printer_name
                        }
                        resolve(data)
                    }).catch(e => {
                        console.log(e)
                        reject(e)
                    })
                }
            })
        },
        loadPaperlessDocRecordList() {
            let that = this
            // 加载手术无纸化记录
            return new Promise((resolve, reject) => {
                if (!this.surgeryId || !this.currentSurgery || !this.currentUser || this.PaperlessEnabled != `1`) {
                    resolve()
                } else {
                    let req = this.myaxios.get(`/api/Operation/PaperlessDocRecord/GetBySurgeryId?surgeryId=${this.surgeryId}`)
                    req.then(data => {
                        that.paperlessDocRecords = data
                        console.log(`paperlessDocRecords`, that.paperlessDocRecords)
                        resolve(data)
                    }).catch(e => {
                        console.log(e)
                        reject(e)
                    })
                }
            })
        },
        init() {
            let that = this
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    reject()
                } else {
                    let req1 = this.myaxios.get(`/api/Preoperative/Apply/Get/${that.surgeryId}`)
                    let req2 = this.myaxios.get(`/api/AcisSystem/DocumentConfig/GetArchived`)
                    this.myaxios
                        .all(req1, req2)
                        .then(([surgery, archives]) => {
                            that.$store.commit(`setCurrentSurgery`, surgery)
                            that.archivedIds = _.filter(archives, d => {
                                return d.biz_surgeryInfo_id == that.surgeryId
                            }).map(d => {
                                return d.docid
                            })
                            resolve(that.archivedIds)
                            console.log(`init 结束`)
                            console.log(that.currentSurgery)
                            console.log(that.currentUser)
                        })
                        .catch(e => {
                            console.log(e)
                            reject(e)
                        })
                }
            })
        },
        loadDocumentList() {
            let that = this
            return new Promise((resolve, reject) => {
                if (!that.currentSurgery || !that.currentSurgery.id || !that.currentUser) { reject() } else {
                    let wardId = that.isOperationWard ? `ow_${that.currentSurgery.dic_operating_ward_id}` : `rw_${that.currentSurgery.dic_recovery_ward_id}`

                    let req = axios.get(`${that.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                        headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                        params: { deptno: `acis2020`, permission: `0-11111111111`, vid: that.currentSurgery.id }
                    })
                    let req2 = that.myaxios.get(`/api/AcisSystem/DocumentConfig/GetNoDeletes`)
                    let req3 = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocPrintList`, {
                        headers: { 'content-type': `application/x-www-form-urlencoded` },
                        params: { deptno: `acis2020`, permission: `0-11111111111`, vid: that.currentSurgery.id }
                    })
                    this.myaxios.all(req, req2, req3).then(([docmanagement, config, printlog]) => {
                        let records = _.cloneDeep(that.paperlessDocRecords)
                        console.log(`请求结果`)
                        console.log(docmanagement)
                        console.log(config)
                        console.log(printlog)
                        console.log(`wardId`)
                        console.log(wardId)

                        let vdoc = _.filter(config, d => {
                            return _.some(d.regions, rg => {
                                return (
                                    (that.isOperationWard ? `ow_${rg.dic_operating_ward_id}` : `rw_${rg.dic_recovery_ward_id}`) == wardId &&
                (d.enum_worker_role == null || d.enum_worker_role == 0 || d.enum_worker_role == (that.currentUser.worker_role == `医生` ? 1 : 2))
                                )
                            })
                        }).map(d => d.document_id)
                        console.log(`vdoc`)
                        console.log(vdoc)
                        this.documentList = _.filter(_.orderBy(docmanagement.data, `PrintOrder`), d => {
                            return _.includes(vdoc, d.DocNo)
                        }).map(d => {
                            let dc = _.find(config, c => c.document_id == d.DocNo)
                            let log = _.find(printlog.data, c => c.DocID == d.DocId)
                            // 增加判断，如果配置区域打印机且为当前区域则按区域打印机进行赋值
                            let printerName = dc && dc.default_printer_name
                            if (that.active_ward && that.active_ward.value && dc && dc.default_printer_name_by_ward) {
                                console.log(that.active_ward.value, dc.default_printer_name_by_ward)
                                let wardPrinterNames = eval(
                                    `(` + dc.default_printer_name_by_ward + `)`
                                )
                                var wardRow = _.find(wardPrinterNames, x => x.ward == that.active_ward.value)
                                if (wardRow && wardRow.printer_name) {
                                    printerName = wardRow && wardRow.printer_name
                                }
                            }
                            d.index = `${d.DocNo}`
                            d.hasChildren = d.IsSurportHtml
                            d.children = []
                            d.label = d.DocName
                            d.default_printer_name = printerName || that.default_printer_name
                            d.is_singleton = dc && dc.is_singleton // 是否单例文书
                            d.is_sign_multiple_times = dc && dc.is_sign_multiple_times // 是否多次签名
                            d.printdt = log && log.DocID
                            d.archived = log && log.Archived
                            d.group_name = dc && dc.group_name
                            d.display_order = dc && dc.display_order
                            return d
                        })
                        that.documentList = _.orderBy(that.documentList, `display_order`)
                        console.log(`过滤vdoc后的documentList`)
                        console.log(that.documentList)
                        _.forEach(that.documentList, d => {
                            if (d.hasChildren) {
                                that.loadInstances(d.DocNo)
                            } else {
                                if (d.uploadRec && !d.archived) {
                                    d.archived = d.uploadRec && d.uploadRec.is_deleted == 0 ? `archived` : ``
                                } else {
                                    d.archived = ``
                                }
                                d.uploadRec = _.find(records, rec => {
                                    return rec.biz_id == parseInt(d.DocId) && rec.biz_type == 3
                                })
                                d.uploadTime = d.uploadRec ? that.$moment(d.uploadRec.last_upload_time).format(`YYYY/MM/DD HH:mm`) : ``
                                if (!d.IsSurportHtml) {
                                    d.archived = _.includes(that.archivedIds, d.DocId.toString())
                                }
                            }
                        })
                        // 文书分组
                        let gdocumentList = []
                        let groups = that.docGroupNamesConfig && that.docGroupNamesConfig.split(`|`)
                        let nogroupdocumentList = _.filter(that.documentList, d => {
                            return !d.group_name || d.group_name.trim() == `` || !_.includes(groups, d.group_name)
                        })
                        let groupdocumentList = _.filter(that.documentList, d => {
                            return d.group_name && d.group_name.trim() != `` && _.includes(groups, d.group_name)
                        })
                        that.docGroupNamesConfig && _.forEach(groups, g => {
                            let groupchildren = _.filter(groupdocumentList, d => {
                                return d.group_name && d.group_name == g
                            }) || []
                            if (groupchildren.length > 0) {
                                gdocumentList.push({
                                    index: g,
                                    label: g,
                                    groupchildren: groupchildren
                                })
                            }
                        })
                        that.newdocumentList = gdocumentList.concat(nogroupdocumentList)
                        if (that.isOnly == `1`) {
                            that.newdocumentList = _.filter(that.newdocumentList, d => {
                                return d.DocNo == that.docId
                            }) || []
                        }
                        console.log(`newdocumentList`)
                        console.log(that.newdocumentList)
                        resolve()
                    })
                }
            })
        },
        loadInstances(docno, docbizid) {
            let that = this
            if (!that.currentSurgery || !that.currentSurgery.id) return
            let records = _.cloneDeep(that.paperlessDocRecords)
            let submenu = _.find(that.documentList, d => {
                return d.DocNo == docno
            })
            if (submenu) {
                let req = axios.get(`${that.$root.DOCSERVICE_BASE}/Wth/QueryInstances`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docid: docno, dept: `acis2020`, vid: that.currentSurgery.id, operator: that.currentUser.dic_worker_name }
                })
                req.then(data => {
                    if (data && data.Content) {
                        let dataContent = data.Content
                        if (that.isTemplate == 0) {
                            let contentInfo = _.filter(dataContent, d => {
                                return d.istemplate == `0`
                            })
                            if (contentInfo && contentInfo.length > 0) {
                                submenu.children = contentInfo.map(d => {
                                    d.index = `${d.docbizid}`
                                    d.docno = submenu.DocNo
                                    d.label = `${d.lastupdatedt}`
                                    d.printdt = d.printdt
                                    d.archiveddt = d.archiveddt
                                    d.uploadRec = records.find(rec => {
                                        return rec.biz_id == parseInt(d.docbizid) && rec.biz_type == 1
                                    })
                                    d.uploadTime = d.uploadRec ? that.$moment(d.uploadRec.last_upload_time).format(`YYYY/MM/DD HH:mm`) : ``
                                    d.caStatus = parseInt(d.caStatus) || 0
                                    d.default_printer_name = submenu.default_printer_name || that.default_printer_name
                                    d.isCenterSign = d.isCenterSign
                                    return d
                                })
                                if (submenu.is_singleton) {
                                    submenu.isCenterSign = contentInfo[0].isCenterSign
                                    submenu.uploadRec = records.find(rec => {
                                        return rec.biz_id == parseInt(data.Content[0].docbizid) && rec.biz_type == 1
                                    })
                                    submenu.uploadTime = submenu.uploadRec ? that.$moment(submenu.uploadRec.last_upload_time).format(`YYYY/MM/DD HH:mm`) : ``
                                    submenu.archived = contentInfo[0].archiveddt && contentInfo[0].archiveddt.trim() != `` ? `archived` : ``
                                }
                            }
                        } else {
                            let contentInfo = _.filter(dataContent, d => {
                                return d.istemplate !== `0`
                            })
                            if (contentInfo && contentInfo.length > 0) {
                                submenu.children = contentInfo.map(d => {
                                    d.index = `${d.docbizid}`
                                    d.docno = submenu.DocNo
                                    d.label = d.docname
                                    d.caStatus = parseInt(d.caStatus) || 0
                                    return d
                                })
                                if (!that.hasRegionTemplateEditPermission) {
                                    submenu.children = _.filter(submenu.children, d => {
                                        return d.istemplate !== `1`
                                    })
                                }
                            }
                        }
                        if (that.docId && submenu.DocNo == that.docId) {
                            // this.collapse = 1 // 日历排程直接跳转到具体的文书左侧隐藏起来
                            if (submenu.children.length > 0) {
                                let nextActive = submenu.children[0]
                                nextActive && that.activeDocument(nextActive)
                            } else {
                                if (submenu.hasChildren && submenu.is_singleton) {
                                    that.loadDocumentPage(submenu)
                                }
                                if (submenu.hasChildren && !submenu.is_singleton) {
                                    that.loadNewDocIdDocPage(submenu)
                                }
                            }
                        }
                        if (docbizid) {
                            let nextActive = _.find(submenu.children, { docbizid: docbizid })
                            nextActive && that.activeDocument(nextActive)
                        }
                    } else {
                        // 没找到实例，下面会自动新开页面
                        if (that.docId && submenu.DocNo == that.docId) {
                            // this.collapse = 1 // 日历排程直接跳转到具体的文书左侧隐藏起来
                            if (submenu.children.length > 0) {
                                let nextActive = submenu.children[0]
                                nextActive && that.activeDocument(nextActive)
                            } else {
                                if (submenu.hasChildren && submenu.is_singleton) {
                                    that.loadDocumentPage(submenu)
                                }
                                if (submenu.hasChildren && !submenu.is_singleton) {
                                    that.loadNewDocIdDocPage(submenu)
                                }
                            }
                        }
                    }
                })
            }
        },
        loadDocumentPage(item) {
            console.log(`loadDocumentPage`, item)
            window.localStorage.removeItem(`docsingleton`)
            window.localStorage.setItem(`docsingleton`, item.is_singleton)
            this.isSaveing = false
            this.singleItems = []
            if (this.hasChanged) {
                this.$confirm(`当前文书已修改, 是否保存?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                })
                    .then(() => {
                        this.nextActive = item
                        this.saveDocument()
                    })
                    .catch(e => {
                        this.hasChanged = false
                        this.activeDocument(item)
                    })
            } else {
                this.activeDocument(item)
            }
        },
        loadActiveDocument(item) {
            return new Promise((resolve, reject) => {
                let that = this
                if (_.has(item, `docbizid`)) {
                    // 打开文书实列
                    let docresult = {
                        docid: item.docid,
                        docno: item.docno,
                        isSurportHtml: true,
                        docName: item.docname,
                        guid: item.guid,
                        docbizid: item.docbizid,
                        default_printer_name: item.default_printer_name || that.default_printer_name,
                        archived: item.archiveddt !== ``,
                        datetype: item.datetype,
                        templateid: item.templateid,
                        templates: item.templates,
                        daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        hasChildren: item.hasChildren,
                        is_singleton: item.is_singleton,
                        is_sign_multiple_times: item.is_sign_multiple_times,
                        caStatus: parseInt(item.caStatus) || 0
                    }
                    resolve(docresult)
                } else if (item.is_singleton) {
                    // 单例文书
                    let docname = `acis2020_${item.DocNo}_${this.surgeryId}`
                    let doced
                    if (item.children && item.children.length > 0) {
                        doced = item.children[0]
                    }
                    this.loadTemplates(item.DocId).then(data => {
                        let docresult = {
                            docid: (doced && doced.docid) || item.DocNo,
                            docno: (doced && doced.docno) || item.DocNo,
                            isSurportHtml: true,
                            docName: doced ? doced.docname : docname,
                            guid: doced ? doced.docguid : this.generateUUID(item.DocId),
                            docbizid: doced ? doced.docbizid : ``,
                            default_printer_name: item.default_printer_name || that.default_printer_name,
                            archived: doced ? doced.archiveddt : ``,
                            datetype: item.DateArea,
                            templateid: undefined,
                            templates: data,
                            daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            hasChildren: !!doced,
                            is_singleton: item.is_singleton,
                            is_sign_multiple_times: item.is_sign_multiple_times,
                            caStatus: parseInt(doced && doced.caStatus) || 0
                        }
                        resolve(docresult)
                    }).catch(e => {
                        let docresult = {
                            docid: (doced && doced.docid) || item.DocNo,
                            docno: (doced && doced.docno) || item.DocNo,
                            isSurportHtml: true,
                            docName: doced ? doced.docname : docname,
                            guid: doced ? doced.docguid : that.generateUUID(item.DocId),
                            docbizid: doced ? doced.docbizid : ``,
                            default_printer_name: item.default_printer_name || that.default_printer_name,
                            archived: doced ? doced.archiveddt : ``,
                            datetype: item.DateArea,
                            templateid: undefined,
                            templates: undefined,
                            daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                            hasChildren: !!doced,
                            is_singleton: item.is_singleton,
                            is_sign_multiple_times: item.is_sign_multiple_times,
                            caStatus: parseInt(doced && doced.caStatus) || 0
                        }
                        resolve(docresult)
                    })
                } else {
                // 打开只读文书
                    let docresult = {
                        docid: item.DocNo,
                        docno: item.DocNo,
                        isSurportHtml: false,
                        archived: this.archivedIds.indexOf(item.DocNo.toString()) > -1,
                        docName: ``,
                        guid: ``,
                        docbizid: ``,
                        default_printer_name: item.default_printer_name || that.default_printer_name,
                        datetype: item.DateArea,
                        templateid: undefined,
                        daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                        is_sign_multiple_times: item.is_sign_multiple_times,
                        hasChildren: false
                    }
                    resolve(docresult)
                }
            })
        },
        activeDocument(item) {
            let that = this
            if (that.isButtonDisabled) return
            that.isButtonDisabled = true
            that.loadActiveDocument(item).then(data => {
                that.activeDoc = data
                that.nextActive = undefined
                that.$nextTick(() => {
                    that.$refs.doc.loadDocument()
                    that.isButtonDisabled = false
                })
            }).catch(e => {
                that.isButtonDisabled = false
            })
            // let that = this
            // let loadItem = {}
            // if (item.is_singleton) {
            //     // 单例文书
            //     let docname = `acis2020_${item.DocNo}_${this.surgeryId}`
            //     let doced
            //     if (item.children && item.children.length > 0) {
            //         doced = item.children[0]
            //     }
            //     loadItem = {
            //         docid: (doced && doced.docid) || item.DocId,
            //         docno: (doced && doced.docno) || item.DocNo,
            //         docname: doced ? doced.docname : docname,
            //         guid: doced ? doced.docguid : this.generateUUID(),
            //         docbizid: doced ? doced.docbizid : ``,
            //         default_printer_name: item.default_printer_name || that.default_printer_name,
            //         archiveddt: doced ? doced.archiveddt : ``,
            //         datetype: item.DateArea,
            //         templateid: undefined,
            //         daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         hasChildren: !!doced,
            //         is_singleton: item.is_singleton,
            //         is_sign_multiple_times: item.is_sign_multiple_times,
            //         caStatus: parseInt(doced && doced.caStatus) || 0
            //     }
            //     debugger
            //     if (!doced || (doced && (!doced.archiveddt || doced.archiveddt.trim() == `` || (doced.archiveddt && doced.archiveddt.trim() != `` && that.isSingletonDocShowTemplate)))) {
            //         this.loadTemplates(item.DocId).then(data => {
            //             loadItem.templates = data
            //         })
            //     }
            // } else {
            //     loadItem = item
            // }
            // if (_.has(loadItem, `docbizid`)) {
            //     // 打开文书实列
            //     this.activeDoc = {
            //         docid: loadItem.docid,
            //         docno: loadItem.docno,
            //         isSurportHtml: true,
            //         docName: loadItem.docname,
            //         guid: loadItem.guid,
            //         docbizid: loadItem.docbizid,
            //         default_printer_name: loadItem.default_printer_name || that.default_printer_name,
            //         archived: loadItem.archiveddt !== ``,
            //         datetype: loadItem.datetype,
            //         templateid: loadItem.templateid,
            //         templates: loadItem.templates,
            //         daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         hasChildren: loadItem.hasChildren,
            //         is_singleton: loadItem.is_singleton,
            //         is_sign_multiple_times: loadItem.is_sign_multiple_times,
            //         caStatus: parseInt(loadItem.caStatus) || 0
            //     }
            // } else {
            //     // 打开只读文书
            //     this.activeDoc = {
            //         docid: loadItem.DocNo,
            //         docno: loadItem.DocNo,
            //         isSurportHtml: false,
            //         archived: this.archivedIds.indexOf(loadItem.DocNo.toString()) > -1,
            //         docName: ``,
            //         guid: ``,
            //         docbizid: ``,
            //         default_printer_name: loadItem.default_printer_name || that.default_printer_name,
            //         datetype: loadItem.DateArea,
            //         templateid: undefined,
            //         daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         toDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
            //         is_sign_multiple_times: loadItem.is_sign_multiple_times,
            //         hasChildren: false
            //     }
            // }
            // this.nextActive = undefined
            // this.$nextTick(() => {
            //     this.$refs.doc.loadDocument()
            // })
        },
        deleteInstanceDocument(item) {
            let that = this
            console.log(`deleteInstanceDocument`, item)
            if (item.archiveddt && item.archiveddt != ``) {
                this.$message.error(`文书已归档，不能删除`)
                return
            }
            if (item.caStatus && item.caStatus > 0) {
                this.$message.error(`签名文书不能删除`)
                return
            }
            let docbizid = item.docbizid
            let docno = item.docno

            this.$confirm(`此操作将永久删除该记录, 是否继续`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.get_doc(`Wth/DeleteInstance`, { docbizid: docbizid, operator: that.currentUser.dic_worker_id })
                req.then(data => {
                    if (docno == that.ztdocID && item.istemplate == `0`) {
                        let req = this.myaxios.put(`/api/AcisSystem/AnalgesicRecord/DelFollowUp?surgeryId=${that.surgeryId}`)
                        req.then(data => {
                            console.log(`删除镇痛随访`)
                        })
                    }
                    that.activeDoc = undefined
                    that.loadDocumentList()
                    that.loadInstances(docno)
                    that.$message.success(`删除成功`)
                })
            })
        },
        // 多例文书新增
        loadNewDocumentView(item) {
            let that = this
            this.document.title = item.DocName
            this.document.docbizid = ``
            this.document.docno = item.index
            this.document.docname = this.$moment().format(`YYYYMMDDHHmmss`)
            this.document.datetype = item.DateArea
            this.document.templateid = undefined
            this.document.default_printer_name = item.default_printer_name || that.default_printer_name
            this.loadTemplates(item.DocId).then(data => {
                this.document.templates = data
                this.document.dialogFormVisible = true
                console.log(`loadNewDocumentView`, this.document)
                this.$nextTick(() => {
                    this.$refs[`doc-new`].loadDocument()
                })
            })
        },

        noSaveWarn(event) {
            if (this.hasChanged) {
                event.preventDefault()
                console.log(`浏览器即将关闭，执行清理操作`)
                event.returnValue = `确定要离开吗？` // 兼容写法
                return `确定要离开吗？` // 兼容写法
            }
        },
        selectDocItems(row) {
            if (row.checked) {
                if (!row.parentId) {
                    row.children && row.children.forEach(ch => {
                        this.$refs.printtb.selectOne(ch, true)
                    })
                } else {
                    // 父级勾选
                    let allrows = this.$refs.printtb.getAllData()
                    let parRow = _.filter(allrows, x => x.id == row.parentId)
                    if (parRow && parRow.length > 0) {
                        this.$refs.printtb.selectOne(parRow[0], true)
                    }
                }
            } else {
                if (!row.parentId) {
                    row.children && row.children.forEach(ch => {
                        this.$refs.printtb.selectOne(ch, false)
                    })
                }
            }
        },
        openbatchPrint() {
            if (!this.surgeryId) return
            let that = this
            that.batchDoc.title = `打印`
            that.batchDoc.visibleSync = true
            that.batchDoc.datalist = []
            let data = []
            _.each(that.documentList, item => {
                var model = {
                    id: item.DocId,
                    docname: item.DocName,
                    docid: item.DocId,
                    docno: item.DocNo,
                    label: item.label,
                    docguid: item.Guid,
                    surgeryId: that.surgeryId,
                    IsSurportHtml: true
                }
                if (item.children.length > 0) {
                    if (item.is_singleton) { // 单例文书
                        model.cindex = item.children[0].index
                        model.docbizid = item.children[0].docbizid
                    } else { // 多例文书
                        model.children = _.each(item.children, citem => {
                            citem.id = citem.index
                            citem.parentId = item.DocId
                            citem.IsSurportHtml = true
                        })
                    }
                    data.push(model)
                } else if (!item.IsSurportHtml) {
                    model.IsSurportHtml = false
                    data.push(model)
                }
            })
            console.log(data)
            that.batchDoc.datalist = data
        },
        openbatchArchive() {
            if (!this.surgeryId) return
            let that = this
            that.batchDoc.title = `归档`
            that.batchDoc.visibleSync = true
            that.batchDoc.datalist = []
            let data = []
            _.each(that.documentList, item => {
                var model = {
                    id: item.DocId,
                    docid: item.DocId,
                    docno: item.DocNo,
                    label: item.label,
                    surgeryId: that.surgeryId,
                    IsSurportHtml: true
                }
                if (item.children.length > 0) {
                    if (item.is_singleton) { // 单例文书
                        if (item.children[0].archiveddt == ``) {
                            model.cindex = item.children[0].index
                            model.docbizid = item.children[0].docbizid
                            data.push(model)
                        }
                    } else { // 多例文书
                        let mch = _.filter(item.children, x => !x.archiveddt || x.archiveddt == ``)
                        if (mch.length > 0) {
                            model.children = _.each(mch, citem => {
                                citem.id = citem.index
                                citem.parentId = item.DocId
                                citem.IsSurportHtml = true
                            })
                            data.push(model)
                        }
                    }
                } else if (!item.IsSurportHtml && !_.includes(that.archivedIds, item.docid)) {
                    model.IsSurportHtml = false
                    data.push(item)
                }
            })
            console.log(data)
            that.batchDoc.datalist = data
        },
        batchPrintDocment() {
            if (!this.surgeryId) return
            let that = this
            let selectRows = that.$refs.printtb.getSelectedRows()
            var printrows = _.filter(selectRows, x => x.docbizid || !x.IsSurportHtml)

            that.batchDoc.visibleSync = false
            this.$store.dispatch(`PRINT_PDF_LIST`, {
                host: this.$root.DOCSERVICE_BASE,
                params: Object.assign(
                    {
                        docs: printrows,
                        id1: this.surgeryId,
                        from: this.$moment().format(`YYYYMMDDHHmm`),
                        to: this.$moment().format(`YYYYMMDDHHmm`),
                        username: this.currentUser.dic_worker_name
                    },
                    this.extraParams
                )
            }).then(() => {
                that.loadDocumentList()
                that.activeDoc && that.$refs.doc.loadDocument()
            })
        },
        batchArchiveDocment() {
            let that = this
            let selectRows = that.$refs.printtb.getSelectedRows()
            var archiverows = _.filter(selectRows, x => x.docbizid || !x.IsSurportHtml)
            console.log(archiverows)
            archiverows.forEach((c, index) => {
                this.callApi(c).then(() => {
                    if (index === archiverows.length - 1) {
                        that.loadDocumentList()
                        that.activeDoc && that.$refs.doc.loadDocument()
                        that.batchDoc.visibleSync = false
                        that.$message.success(`归档成功`)
                    }
                })
            })
        },
        BeforeArchiveCheck(type, item) {
            return new Promise((resolve, reject) => {
                let that = this
                let req = this.myaxios.post(`/api/AcisSystem/DocumentConfig/BeforeArchiveCheck?surgeryId=${that.surgeryId}&docid=${item.docid}&docbizid=${item.docbizid}&operatorType=${type}`)
                req.then(res => {
                    if (res && res != ``) {
                        this.$message.error(res)
                        reject()
                    } else {
                        resolve()
                    }
                }).catch(e => {
                    console.log(e)
                    reject()
                })
            })
        },
        callApi(c) {
            return new Promise((resolve) => {
                let that = this
                if (c.IsSurportHtml) { // 是否可编辑文书
                    // 归档前加校验
                    if (that.docProcBeforeArchive) {
                        that.BeforeArchiveCheck(`归档`, c).then(() => {
                            let req = axios.get(`${that.$root.DOCSERVICE_BASE}/Wth/ArchiveInstance`, {
                                headers: { 'content-type': `application/x-www-form-urlencoded` },
                                params: { docbizid: c.docbizid, operator: that.currentUser.dic_worker_name }
                            })
                            req.then(data => {
                                that.savePaperlessRecord(c.docbizid)
                                resolve()
                            })
                        })
                    } else {
                        let req = axios.get(`${that.$root.DOCSERVICE_BASE}/Wth/ArchiveInstance`, {
                            headers: { 'content-type': `application/x-www-form-urlencoded` },
                            params: { docbizid: c.docbizid, operator: that.currentUser.dic_worker_name }
                        })
                        req.then(data => {
                            that.savePaperlessRecord(c.docbizid)
                            resolve()
                        })
                    }
                } else {
                    let data = {
                        id: 0,
                        biz_surgeryInfo_id: that.surgeryId,
                        docdt: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        archivedt: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        docname: `${this.$moment().format(`YYYYMMDD`)}_${c.docid}_${this.surgeryId}`,
                        docid: c.docid
                    }
                    let req = that.myaxios.put(`/api/AcisSystem/DocumentConfig/Archive`, data)
                    req.then(data => {
                        that.archivedIds.push(data.docid)
                        that.saveReadOnlyPaperlessRecord(data)
                        resolve()
                    })
                }
            })
        },
        batchDocClose() {
            let that = this
            that.loadDocumentList()
            that.activeDoc && that.$refs.doc.loadDocument()
            that.batchDoc.visibleSync = false
        },
        changescalenum(num) {
            let that = this
            let oldnum = that.scalenum
            var newnum = oldnum + num
            if (newnum < 1) {
                that.scalenum = 1
                that.$message.error(`已到缩小最小值1.0倍`)
            } else if (newnum > 1.5) {
                that.scalenum = 1.5
                that.$message.error(`已到放大最大值1.5倍`)
            } else {
                that.scalenum = newnum
            }
        },
        triggerCollapse() {
            if (this.collapse == 0) {
                this.collapse = 1
            } else {
                this.collapse = 0
            }
            this.$emit(`triggerCollapse`, this.collapse)
        },
        loadTemplates(docno) {
            if (!this.surgeryId) return
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryTemplateInstances`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docid: docno, deptno: ``, vid: this.surgeryId, operator: this.currentUser.dic_worker_name }
                })
                req.then(res => {
                    resolve(
                        res.Content &&
                            res.Content.map(d => {
                                return {
                                    label: d.docname,
                                    value: parseInt(d.docbizid),
                                    group: d.istemplate == `1` ? `区域模板` : `私有模板`,
                                    docguid: d.docguid
                                }
                            })
                    )
                })
            })
        },
        // createDocment(item) {
        //     this.guid = this.generateUUID()
        //     this.docno = _.parseInt(item.DocNo)
        //     this.$refs.doc.loadDocument()
        // },
        changed(changed) {
            this.hasChanged = changed
        },
        saveDoc() {
            let that = this
            if (this.activeDoc && this.activeDoc.archived) {
                return
            }
            if (that.activeDoc.docno == that.ztdocID && this.isTemplate == 0) {
                let req = this.myaxios.get(`/api/AcisSystem/AnalgesicRecord/GetAnalgesicRecord?surgeryId=${that.surgeryId}`)
                req.then(data => {
                    if (data != null && data.id > 0) {
                        this.$confirm(`是否记录本次操作为最新随访?`, `提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            let req = this.myaxios.put(`/api/AcisSystem/AnalgesicRecord/PutFollowUp?surgeryId=${that.surgeryId}`)
                            req.then(data => {
                                that.saveDocument()
                                that.$message.success(`已随访！`)
                            })
                        }).catch(() => {
                            that.saveDocument()
                        })
                    } else {
                        that.saveDocument()
                    }
                }).catch(() => {
                    that.saveDocument()
                })
            } else {
                that.saveDocument()
            }
        },
        saveDocument() {
            return new Promise((resolve, reject) => {
                if (this.activeDoc && this.activeDoc.archived) {
                    resolve()
                } else {
                    this.isSaving = true
                    this.visible = false
                    resolve(this.$refs.doc.save())
                }
            })
        },
        afterActiveSaved() {
            this.hasChanged = false
            this.loadInstances(this.activeDoc.docno)

            if (this.activeDoc.is_singleton && this.activeDoc.templateid) {
                this.activeDoc.templateid = undefined
                this.templateChange(false)
            } else {
                if (this.nextActive) {
                    this.activeDocument(this.nextActive)
                } else {
                    this.$set(this.activeDoc, `hasChildren`, true)
                }
            }
            this.isSaving = false
        },
        generateUUID(docId) {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + parseInt(docId) + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
            })
            console.log(uuid)
            return uuid
        },
        archive(c) {
            let that = this
            if (!that.surgeryId) return
            if (c.isSurportHtml) {
                if (c.templateid || this.hasChanged) {
                    this.$message.error(`归档之前请先保存！`)
                    return
                }
                // 归档前加校验
                if (this.docProcBeforeArchive) {
                    that.BeforeArchiveCheck(`归档`, c).then(() => {
                        that.toArchive()
                    })
                } else {
                    this.toArchive()
                }
            } else {
                this.$confirm(`确定要将此文书归档吗, 是否继续?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let data = {
                        id: 0,
                        biz_surgeryInfo_id: this.surgeryId,
                        docdt: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        archivedt: this.$moment().format(`YYYY-MM-DD HH:mm:ss`),
                        docname: `${this.$moment().format(`YYYYMMDD`)}_${c.docid}_${this.surgeryId}`,
                        docid: c.docid
                    }
                    let req = this.myaxios.put(`/api/AcisSystem/DocumentConfig/Archive`, data)
                    req.then(data => {
                        this.archivedId = data.id
                        this.archivedIds.push(data.docid)
                        this.activeDoc.archived = true
                        this.saveReadOnlyPaperlessRecord(data)
                        this.loadInstances(this.activeDoc.docno)
                    })
                    setTimeout(this.loadDocumentList, 3000)
                })
            }
        },
        toArchive() {
            let awaitIndex = 0
            let awaitUntilEqual = () => {
                awaitIndex++
                if (this.isSaving == true && awaitIndex < 500) {
                    requestAnimationFrame(awaitUntilEqual)
                    return
                }
                if (awaitIndex >= 500) {
                    this.$message.error(`操作超时，请刷新后重试~`)
                } else {
                    this.$refs.doc.archive()
                }
            }
            awaitUntilEqual()
            setTimeout(this.loadDocumentList, 3000)
        },
        disArchive(c) {
            if (c.isSurportHtml) {
                if (c.templateid) {
                    this.$message.error(`模板不能取消归档,请选择左侧文书刷新！`)
                    return
                }
                let that = this
                if (that.docProcBeforeArchive) {
                    that.BeforeArchiveCheck(`取消归档`, c).then(() => {
                        that.todisArchive(c)
                    })
                } else {
                    that.todisArchive(c)
                }
            } else {
                this.checkPaperlessDoc(c && c.docbizid).then(result => {
                    if (result) {
                        let req1 = this.myaxios.get(`/api/AcisSystem/DocumentConfig/GetArchivedByDocId?docid=${c.docid}`)
                        req1.then(data => {
                            return data.id
                        }).then(id => {
                            let req = this.myaxios.put(`/api/AcisSystem/DocumentConfig/CancleArchive?archiveid=${id}`)
                            req.then(data => {
                                this.archivedIds.splice(this.archivedIds.indexOf(data.docid), 1)
                                this.activeDoc.archived = false
                                this.deleteReadOnlyPaperlessRecord(data.docid)
                                this.loadInstances(this.activeDoc.docno)
                                setTimeout(this.loadDocumentList, 3000)
                            })
                        })
                    }
                })
            }
        },
        todisArchive(c) {
            this.checkPaperlessDoc(c && c.docbizid).then(result => {
                if (result) {
                    let awaitIndex = 0
                    let awaitUntilEqual = () => {
                        awaitIndex++
                        if (this.isSaving == true && awaitIndex < 500) {
                            requestAnimationFrame(awaitUntilEqual)
                            return
                        }
                        if (awaitIndex >= 500) {
                            this.$message.error(`操作超时，请刷新后重试~`)
                        } else {
                            this.$refs.doc.disArchive()
                            setTimeout(this.loadDocumentList, 3000)
                        }
                    }
                    awaitUntilEqual()
                }
            })
        },
        // 无纸化文档校验
        checkPaperlessDoc(bizid) {
            return new Promise((resolve, reject) => {
                let that = this
                if (that.paperlessDocVerification && that.paperlessDocVerification != ``) {
                    let postdata = {
                        biz_surgery_info_id: that.surgeryId,
                        biz_type: 1,
                        biz_id: bizid
                    }
                    let req = this.myaxios.post(`/api/Operation/Home/checkPaperlessDoc`, postdata)
                    req.then(data => {
                        if (data) {
                            if (!data.Status && data.Message) {
                                that.$message.error(data.Message)
                            }
                            resolve(data && data.Status)
                        } else {
                            resolve(true)
                        }
                    })
                        .catch(e => {
                            console.log(e)
                            resolve(false)
                        })
                } else {
                    resolve(true)
                }
            })
        },
        printDocment(c) {
            let that = this
            if (that.checkPrintByDoc && that.checkPrintByDoc == `1` && that.activeDoc.isSurportHtml) {
                this.$refs.doc.checkprint()
            } else {
            // 归档的文书不需要保存
                if (that.activeDoc.isSurportHtml && !that.docSaveByBtn) { // && !this.currentSurgery.is_sealed && !this.activeDoc.archived
                    that.saveDocument()
                }
                // 打印前加校验
                if (this.docProcBeforeArchive) {
                    that.BeforeArchiveCheck(`打印`, c).then(() => {
                        that.toPrint()
                    })
                } else {
                    that.toPrint()
                }
            }
        },
        aftercheckprint() {
            let that = this
            // 归档的文书不需要保存
            if (that.activeDoc.isSurportHtml && !that.docSaveByBtn) { // && !this.currentSurgery.is_sealed && !this.activeDoc.archived
                that.saveDocument()
            }
            that.toPrint()
        },
        toPrint() {
            let awaitIndex = 0
            let awaitUntilEqual = () => {
                awaitIndex++
                if (this.isSaving == true && awaitIndex < 500) {
                    requestAnimationFrame(awaitUntilEqual)
                    return
                }
                let savefalg = window.localStorage.getItem(`savefalg`)
                if (savefalg == `False`) {
                    this.$message.error(`请先保存文书`)
                    return
                }
                if (this.isCanPrintDocAfterArchived && this.isCanPrintDocAfterArchived == `1`) {
                    if (!this.currentSurgery.is_sealed && !this.activeDoc.archived) {
                        this.$message.error(`请先归档`)
                        return
                    }
                }

                if (awaitIndex >= 500) {
                    this.$message.error(`打印超时，请刷新后重试~`)
                } else {
                    this.$refs.doc.print()
                    setTimeout(this.loadDocumentList, 3000)
                }
            }

            awaitUntilEqual()
        },
        createDocument() {
            this.$refs[`doc-new`].save()
        },
        saveAndPrintDocument() {
            this.$refs[`doc-new`].saveAndprint()
            setTimeout(() => {
                let awaitIndex = 0
                let awaitUntilEqual = () => {
                    awaitIndex++
                    if (this.isSaving == true && awaitIndex < 500) {
                        requestAnimationFrame(awaitUntilEqual)
                        return
                    }
                    let savefalg = window.localStorage.getItem(`savefalg`)
                    if (savefalg == `False`) {
                        this.$message.error(`请先保存文书`)
                        return
                    }
                    if (this.isCanPrintDocAfterArchived && this.isCanPrintDocAfterArchived == `1`) {
                        if (!this.currentSurgery.is_sealed && !this.activeDoc.archived) {
                            this.$message.error(`请先归档`)
                            return
                        }
                    }
                    if (awaitIndex >= 500) {
                        this.$message.error(`打印超时，请刷新后重试~`)
                    } else {
                        this.$refs[`doc-new`].print()
                        setTimeout(this.loadDocumentList, 3000)
                    }
                }

                awaitUntilEqual()
            }, 1000)
        },
        afterDocumentSavedAndPrint() {
        },
        // 根据DocId 直接定位加载对应文书页面
        loadNewDocIdDocPage(item) {
            let that = this
            that.activeDoc = {
                title: item.DocName,
                docbizid: ``,
                docno: item.index,
                isSurportHtml: true,
                docName: this.$moment().format(`YYYYMMDDHHmmss`),
                guid: item.guid,
                datetype: item.DateArea,
                templateid: undefined,
                default_printer_name: item.default_printer_name || that.default_printer_name,
                is_sign_multiple_times: item.is_sign_multiple_times,
                templates: null
            }
            this.loadTemplates(item.DocId).then(data => {
                that.activeDoc.templates = data
                this.$nextTick(() => {
                    that.$refs[`doc`].loadDocument()
                })
            })
        },
        afterDocumentSaved() {
            this.document.dialogFormVisible = false
            this.loadInstances(this.document.docno, this.document.docbizid)
        },
        saveAsTemplate(type) {
            this.saveDocument().then(() => {
                this.$refs.doc.saveAsTemplate(type)
            })
        },
        afterSaveAsTemplate() {
            console.log(this.activeDoc)
            this.loadInstances(this.activeDoc.docno, this.activeDoc.docbizid)
        },
        dataSynchronous() {
            this.$confirm(`确定要同步文书数据, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                if (this.activeDoc.isSurportHtml && !this.docSaveByBtn) {
                    this.saveDocument()
                }
                this.$refs.doc.dataUpdate()
                this.init().then(() => {
                    this.$refs[`doc`].loadDocument()
                }).catch(e => {
                    console.log(e)
                })
                this.loadDocumentList()
            })
        },
        // 发送签名
        sendWztSign() {
            if (this.activeDoc.isSurportHtml && !this.docSaveByBtn) { // && !this.currentSurgery.is_sealed && !this.activeDoc.archived
                this.saveDocument()
            }
            this.$confirm(`发送签名后数据不可修改，确定发送用户签名？`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                this.$refs.doc.wztPdfUploadInstance()
            })
        },
        // 取消签名
        cancelWztSign() {
            this.$confirm(`确定取消用户签名？`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                this.$refs.doc.wztCaRevokePdf()
            })
        },
        // 直接刷新
        refreshDocument() {
            this.$confirm(`确定要刷新当前文书数据, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    if (this.activeDoc.isSurportHtml && !this.docSaveByBtn) {
                        this.saveDocument()
                    }
                    this.$refs.doc.dataUpdate()
                    this.init().then(() => {
                        this.$refs[`doc`].loadDocument()
                    }).catch(e => {
                        console.log(e)
                    })
                    this.loadDocumentList()
                })
                .catch(e => {
                    this.hasChanged = false
                })
        },
        afterArchive() {
            this.activeDoc.archived = true
            // 保存无纸化记录
            this.savePaperlessRecord(this.activeDoc.docbizid)
            // 保存互联互通CDA记录
            this.saveCDARecord(this.activeDoc.docbizid)
            this.loadInstances(this.activeDoc.docno)
        },
        afterDisarchive() {
            this.activeDoc.archived = false
            this.deletePaperlessRecord(this.activeDoc.docbizid)
            this.deleteCDARecord(this.activeDoc.docbizid)
            this.loadInstances(this.activeDoc.docno)
        },
        templateChange(refresh) {
            if (!this.activeDoc.docbizid) {
                this.$message.error(`切换模板过快了~~，请稍后重试呀`)
                return
            }
            let curDoc = _.find(this.singleItems, d => d.docno == this.activeDoc.docno)
            if (!curDoc) {
                curDoc = {
                    docno: this.activeDoc.docno,
                    docbizid: this.activeDoc.docbizid,
                    guid: this.activeDoc.guid,
                    docname: this.activeDoc.docname
                }
                this.singleItems.push(curDoc)
            }
            if (!this.activeDoc.templateid || this.activeDoc.templateid <= 0) {
                console.log(`模板，取消`)
                this.activeDoc.templateid = undefined
                this.activeDoc.docname = curDoc.docname
                this.activeDoc.docbizid = curDoc.docbizid
                this.activeDoc.guid = curDoc.guid
                if (refresh != false) {
                    this.$nextTick(() => {
                        this.$refs[`doc`].loadDocument()
                    })
                }
            } else {
                console.log(`模板，选择`)
                let choseTmpt = _.find(this.activeDoc.templates, c => c.value == this.activeDoc.templateid)
                if (!choseTmpt) {
                    this.$message.error(`切换模板失败了~~，请稍后重试呀`)
                    return
                }
                this.activeDoc.docname = choseTmpt.label
                this.activeDoc.docbizid = choseTmpt.value.toString()
                this.activeDoc.guid = choseTmpt.docguid
                this.$nextTick(() => {
                    this.$refs[`doc`].loadDocument(curDoc.docno, curDoc.docbizid, curDoc.guid)
                })
            }
        },
        occurdateChange() {
            let r = { ...this.activeDoc }
            r.fromDt = this.activeDoc.occurdate
            r.toDt = this.activeDoc.occurdate
            this.activeDoc = r
            this.$nextTick(() => {
                this.$refs[`doc`].loadDocument()
            })
        },
        daterangeChange() {
            let r = { ...this.activeDoc }
            r.fromDt = this.activeDoc.daterange[0]
            r.toDt = this.activeDoc.daterange[1]
            this.activeDoc = r
            this.$nextTick(() => {
                this.$refs[`doc`].loadDocument()
            })
        },
        savePaperlessRecord(docbizid) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }

            // 保存无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
            if (docbizid > 0) {
                // 查询归档信息
                let req1 = axios.get(`${this.$root.DOCSERVICE_BASE}/wth/QueryInstanceById`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docbizid: docbizid }
                })

                req1.then(doc => {
                    if (!doc || doc.ArchivedDt == ``) {
                        return Promise.resolve({})
                    }
                    let recData = {
                        biz_id: doc.Content.Sysid,
                        biz_surgery_info_id: doc.Content.Vid,
                        biz_type: 1, // 0麻醉单和苏醒单，1文书
                        doc_name: doc.Content.DocName,
                        file_path: `${doc.Content.Guid}.pdf`,
                        create_by: this.currentUser.username,
                        create_by_name: this.currentUser.dic_worker_name,
                        create_time: doc.Content.ArchivedDt
                    }
                    return this.myaxios.post(`api/Operation/PaperlessDocRecord/Add`, recData)
                })
            }
            return Promise.resolve({})
        },
        deletePaperlessRecord(docbizid) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }

            // 保存无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
            if (docbizid > 0) {
                return this.myaxios.put(`api/Operation/PaperlessDocRecord/LogicDel?biz_id=${docbizid}&biz_type=1`)
            }
            return Promise.resolve({})
        },
        saveCDARecord(docbizid) {
            if (this.$root.OpenCDAEnabled != 1) {
                return Promise.resolve({})
            }

            // 保存互联互通记录
            if (docbizid > 0) {
                // 查询归档信息
                let req1 = axios.get(`${this.$root.DOCSERVICE_BASE}/wth/QueryInstanceById`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docbizid: docbizid }
                })

                req1.then(doc => {
                    if (!doc || doc.ArchivedDt == ``) {
                        return Promise.resolve({})
                    }
                    let recData = {
                        biz_id: doc.Content.Sysid,
                        biz_surgery_info_id: doc.Content.Vid,
                        biz_type: 1, // 0麻醉单和苏醒单，1文书
                        archive_doc_name: doc.Content.DocName,
                        archive_file_path: `${doc.Content.Guid}.pdf`,
                        create_by: this.currentUser.username,
                        create_by_name: this.currentUser.dic_worker_name,
                        create_time: doc.Content.ArchivedDt,
                        enum_doc_type: doc.Content.DocId
                    }
                    return this.myaxios.post(`api/Operation/CDARecord/Add`, recData)
                })
            }
            return Promise.resolve({})
        },
        deleteCDARecord(docbizid) {
            if (this.$root.OpenCDAEnabled != 1) {
                return Promise.resolve({})
            }

            // 删除互联互通CDA记录
            if (docbizid > 0) {
                return this.myaxios.put(`api/Operation/CDARecord/LogicDel?biz_id=${docbizid}&biz_type=1`)
            }
            return Promise.resolve({})
        },
        saveReadOnlyPaperlessRecord(data) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }
            if (data.id) {
                let recData = {
                    biz_id: data.docid,
                    biz_surgery_info_id: data.biz_surgeryInfo_id,
                    biz_type: 3, // 0麻醉单和苏醒单，1文书,3 只读文书
                    doc_name: data.docname,
                    file_path: `${data.docname}.pdf`,
                    create_by: this.currentUser.username,
                    create_by_name: this.currentUser.dic_worker_name,
                    create_time: this.$moment(data.archivedt).format(`YYYY-MM-DD HH:mm:ss`)
                }
                this.myaxios.post(`api/Operation/PaperlessDocRecord/Add`, recData)
                setTimeout(this.loadDocumentList, 3000)
            }

            return Promise.resolve({})
        },
        deleteReadOnlyPaperlessRecord(docid) {
            if (this.$root.PaperlessEnabled != 1) {
                return Promise.resolve({})
            }
            if (docid) {
                this.myaxios.put(`api/Operation/PaperlessDocRecord/LogicDel?biz_id=${docid}&biz_type=3`)
                setTimeout(this.loadDocumentList, 3000)
            }
            return Promise.resolve({})
        },
        loadCaStatus(newDoc) {
            let req1 = axios.get(`${this.$root.DOCSERVICE_BASE}/wth/QueryInstanceById`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` },
                params: { docbizid: newDoc && newDoc.docbizid || 0 }
            })
            req1.then(doc => {
                if (doc.Content && (newDoc && newDoc.caStatus || 0) != (doc.Content.CaStatus || 0)) {
                    console.log(`CaStatus状态变更轮询`)
                    console.log(newDoc.caStatus)
                    console.log(doc.Content.CaStatus)
                    this.activeDoc.caStatus = doc.Content.CaStatus
                    this.loadDocumentList()
                    this.$refs.doc.loadDocument()
                }
            }).catch(e => console.log(e))
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    beforeRouteLeave(to, from, next) {
        let that = this
        if (that.hasChanged) {
            that.$confirm(`提示`, {
                title: `提示`,
                message: `文书尚未保存，请确认是否保存`,
                confirmButtonText: `确认`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                that.saveDocument()
            }).catch(e => {
                next()
            })
        } else {
            next()
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            let that = this
            that.surgeryId = newUrl.query.surgery_id
            that.activeDoc = undefined
            that.collapse = 0
            that.archivedIds = []
            that.docId = newUrl.query.docId
            if (that.docId) {
                that.collapse = 1
            }
            that.init().then(() => {
                that.loadPaperlessDocRecordList(that.surgeryId).then(() => {
                    that.loadDocumentList()
                }).catch(e => {
                    console.log(`loadPaperlessDocRecordList error`, e)
                })
            }).catch(e => {
                console.log(`init error`, e)
            })
        },
        'document.occurdate': function() {
            this.document.fromDt = this.document.occurdate
            this.document.toDt = this.document.occurdate
            this.$nextTick(() => {
                this.$refs[`doc-new`].loadDocument()
            })
        },
        'document.daterange': function() {
            this.document.fromDt = this.document.daterange[0]
            this.document.toDt = this.document.daterange[1]
            this.$nextTick(() => {
                this.$refs[`doc-new`].loadDocument()
            })
        },
        'document.templateid': function() {
            this.$nextTick(() => {
                this.$refs[`doc-new`].loadDocument()
            })
        },
        isTemplate: function() {
            this.loadDocumentList()
        },
        activeDoc: function(newDoc, oldDoc) {
            console.log(`activeDoc`)
            console.log(newDoc && newDoc.caStatus)
            if (this.useExternalSignature && this.useExternalSignature == `1`) {
                clearInterval(this.interval)
                this.interval = setInterval(() => {
                    this.loadCaStatus(newDoc)
                }, 3000)
            }
        },
        hasChanged(value) {
            if (value) {
                window.removeEventListener(`beforeunload`, this.noSaveWarn)
                window.addEventListener(`beforeunload`, this.noSaveWarn)
            } else {
                window.removeEventListener(`beforeunload`, this.noSaveWarn)
            }

            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `saveChangedWarn`,
                    isChange: value
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    }
}
</script>
<style scoped lang="less" >
@h-header: 30px;
.pdf {
    width: 100%;
    height: 100%;
    padding: @h-header 0px;
    /*background: whitesmoke;*/
}
.pdf-header {
    line-height: @h-header;
    background: whitesmoke;
    position: absolute;
    width: 100%;
    height: @h-header;
    z-index: 2;
}
ul,
li {
    list-style: none;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
::-webkit-scrollbar {
    display: none; /*隐藏滚动条*/
}
</style>
<style lang="less">
.document-list {
    .el-submenu__icon-arrow {
        // position: absolute !important;
        left: -220px;
    }
    .btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -12px;
        font-size: 16px;
        z-index: 2;
    }
    .el-menu-item-new {
        height: 56px;
        line-height: 56px;
        font-size: 14px;
        color: #303133;
        padding: 0 20px;
        list-style: none;
        cursor: pointer;
        position: relative;
        transition: border-color 0.3s, background-color 0.3s, color 0.3s;
        box-sizing: border-box;
        white-space: nowrap;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Document/Index2.vue